export default {
  savePageAsDefault: 'Ustaw bieżącą stronę jako stronę główną',
  resetDefaultPage: 'Przywróć ustawienia domyślne',
  bugReport: 'Zgłoszenie błędu',
};
